const REACHABILITY_PROBE_PATH = '/manifest.json';

export const isServerReachable = async () => {
  try {
    const response = await fetch(`${REACHABILITY_PROBE_PATH}?reachability=${Date.now()}`, {
      cache: 'no-store',
      method: 'HEAD',
    });

    return response.ok;
  } catch {
    return false;
  }
};
